// import React, { useState, useEffect, useRef } from "react";

// import {
//     Box,
//     Button,
//     Typography,
//     Tabs,
//     Tab,
//     Checkbox,
//     FormControlLabel,
// } from "@mui/material";
// import DatePicker from "react-datepicker";
// import arrowLeft from "../../../src/assests/images/arrow-left.svg";
// import arrowRight from "../../../src/assests/images/arrow-right.png";
// import doubleArrowLeft from "../../../src/assests/images/double-arrow-left.svg";
// import doubleArrowRight from "../../../src/assests/images/double-arrow-right.svg";
// import {filterdata} from "./api"
// import { getToken } from "../../utils/utils";
// interface FilterPopupProps {
//     filter: any;
//     selectedDate: Date | null;
//     setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
//     selectedTab: number;
//     setSelectedTab: (tabIndex: number) => void;
//     applyFilters: () => void; 
//     filters: Filters; 
//         setFilters: React.Dispatch<React.SetStateAction<Filters>>; 
//         applydetailes: boolean;
//   setapply: (value: boolean) => void;
//   selectedTab1: number;
//   setSelectedTab1: React.Dispatch<React.SetStateAction<number>>;
// }

// interface Filters {
//     [key: string]: {
//       [key: string]: {
//         checked: boolean;
//         id: number;
//       };
//     };
//   }
  
// function FilterPopupTeam({ filter, setSelectedDate, selectedDate,filters,setFilters,applyFilters,  applydetailes,
//   setapply ,selectedTab1,setSelectedTab1}: FilterPopupProps) {
//     const [selectedTab, setSelectedTab] = useState(0);
//     const popupRef = useRef<HTMLDivElement>(null);
//     // const [filters, setFilters] = useState<Filters>({
//     //     team: {},
//     //     module: {},
//     //     creationDate: {},
//     // });
//     const token=getToken()
//     const [teamIdMap, setTeamIdMap] = useState<Record<string, number>>({});
//     const [moduleIdMap, setModuleIdMap] = useState<Record<string, number>>({});
//     useEffect(() => {
//         const fetchFilterData = async () => {
//           try {
//             const res = await filterdata(token);
      
//             const { team = [], module = [] } = res?.data?.data || {};
      
//             const teamIdMap: Record<string, number> = {};
//             team.forEach((item: any) => {
//               if (item.name !== null) teamIdMap[item.name] = item.id;
//             });
      
//             const moduleIdMap: Record<string, number> = {};
//             module.forEach((item: any) => {
//               if (item.name !== null) moduleIdMap[item.name] = item.id;
//             });
      
//             setTeamIdMap(teamIdMap); // Set team map
//             setModuleIdMap(moduleIdMap); // Set module map
      
//             const teamOptions = {
//                 all: { checked: false, id: -1 },
//                 ...Object.fromEntries(
//                   team
//                     .filter((item: any) => item.name !== null)
//                     .map((item: any) => [item.name, { checked: false, id: item.id }])
//                 ),
//               };
              
//               const moduleOptions = {
//                 all: { checked: false, id: -1 },
//                 ...Object.fromEntries(
//                   module
//                     .filter((item: any) => item.name !== null)
//                     .map((item: any) => [item.name, { checked: false, id: item.id }])
//                 ),
//               };
              
//               setFilters({
//                 team: teamOptions,
//                 module: moduleOptions,
//                 creationDate: {}, // You can update this similarly if needed
//               });
              
//           } catch (error) {
//             console.error("Error fetching filter data:", error);
//           }
//         };
      
//         fetchFilterData();
//       }, [token]);
      
      


//     const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
//         setSelectedTab1(newValue);
//     };
//     // useEffect(() => {
//     //     const handleClickOutside = (event: MouseEvent) => {
//     //         if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
//     //             console.log("Clicked outside! Closing...");
//     //             filter?.onClose?.();
//     //         }
//     //     };

//     //     const handleEscape = (event: KeyboardEvent) => {
//     //         if (event.key === "Escape") {
//     //             filter?.onClose?.();
//     //         }
//     //     };

//     //     document.addEventListener("click", handleClickOutside, true); // Use capture phase
//     //     document.addEventListener("keydown", handleEscape);

//     //     return () => {
//     //         document.removeEventListener("click", handleClickOutside, true);
//     //         document.removeEventListener("keydown", handleEscape);
//     //     };
//     // }, [filter]);
//     const handleFilterChange = (
//         tabKey: string,
//         event: React.ChangeEvent<HTMLInputElement>
//       ) => {
//         const { name, checked } = event.target;
//       console.log(tabKey, "tabKeyssssssssssssssss")
//         setFilters((prevFilters) => {
//           const updatedTab = { ...prevFilters[tabKey] };
      
//           if (name === "all") {
//             // Select or deselect all
//             Object.keys(updatedTab).forEach((key) => {
//               updatedTab[key] = {
//                 ...updatedTab[key],
//                 checked,
//               };
//             });
//           } else {
//             updatedTab[name] = {
//               ...updatedTab[name],
//               checked,
//             };
//           }
      
//           return {
//             ...prevFilters,
//             [tabKey]: updatedTab,
//           };
//         });
//       };

      
//       const clearAllFilters = () => {
//         const clearedFilters: Filters = Object.fromEntries(
//           Object.entries(filters).map(([tabKey, options]) => [
//             tabKey,
//             Object.fromEntries(
//               Object.entries(options).map(([name, value]) => [
//                 name,
//                 { ...value, checked: false },
//               ])
//             ),
//           ])
//         );
//         setFilters(clearedFilters);
//       };
      
  
// console.log(filters, "filterseeeeeeeeeeeww")
//     const tabsConfig = [
//         { label: "Team", key: "team" },
//         { label: "Module", key: "module" },
//         { label: "Creation Date", key: "creationDate" },
//     ];

  




// console.log(selectedTab1, "selectedTab44555555555")
// console.log(selectedDate, "selectedDatekkkkkkkkk")

//     return (
//         <Box ref={popupRef}
//             sx={{
//                 position: "absolute",
//                 width: "480px",
//                 right: "3%",
//                 backgroundColor: "#fff",
//                 padding: "20px",
//                 borderRadius: "10px",
//                 opacity: 1,
//                 boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//                 zIndex: 9999,
//             }}
//         >
//             <Box sx={{ width: "100%", display: "flex" }}>
//                 {/* Vertical Tabs */}
//                 <Box sx={{ width: "200px", borderRight: "1px solid #ddd" }}>
//                     <Tabs
//                         orientation="vertical"
//                         value={selectedTab1}
//                         onChange={handleTabChange}
//                         aria-label="Filter tabs"
//                         sx={{
//                             borderRight: 1,
//                             borderColor: "divider",
//                             whiteSpace: "nowrap",
//                             fontSize: "14px",
//                             color: "#282829",
//                             fontWeight: "500",
//                             textAlign: "left",
//                         }}
//                     >
//                         {tabsConfig.map((tab, index) => (
//                             <Tab key={tab.key} label={tab.label} sx={tabStyles} />
//                         ))}
//                     </Tabs>
//                 </Box>

//                 {/* Tab Content */}
//                 <Box sx={{ paddingLeft: "20px", flexGrow: 1 }}>
//                     {tabsConfig.map((tab, index) =>
//                         selectedTab1 === index ? (
//                             <Box key={tab.key} sx={{ marginBottom: "16px" }}>
//                                 {tab.key === "creationDate" ? (
//                                     <Box>

//                                         <style>
//                                             {`
//                                          .static-datepicker {
//                                           position: static !important;
//                                           box-shadow: none !important; /* Removes box shadow */
//                                           border: 0px solid #ddd; /* Optional: Add border if needed */
                                    
//                                         }
//                                         `}
//                                         </style>


//                                         <DatePicker
//                                             dateFormat="dd/MM/yyyy"
//                                             selected={selectedDate}
//                                             onChange={(date) => {
//                                                 setSelectedDate(date);
//                                                 console.log(date, "Selected Datesssssssssss");
//                                             }}
//                                             inline
//                                             calendarClassName="static-datepicker"
//                                             dayClassName={(date) =>
//                                                 selectedDate && date.toDateString() === selectedDate.toDateString()
//                                                     ? "selected-date"
//                                                     : ""
//                                             }
//                                             renderCustomHeader={({ date, decreaseMonth, increaseMonth, decreaseYear, increaseYear }) => (
//                                                 <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
//                                                     <button onClick={decreaseYear}>
//                                                         <img src={doubleArrowLeft} alt="double left arrow" />
//                                                     </button>
//                                                     <button onClick={decreaseMonth}>
//                                                         <img src={arrowLeft} alt="left arrow" />
//                                                     </button>
//                                                     <span style={{ margin: "0 10px" }}>
//                                                         {date.toLocaleString("default", { year: "numeric", month: "long" })}
//                                                     </span>
//                                                     <button onClick={increaseMonth}>
//                                                         <img src={arrowRight} alt="right arrow" />
//                                                     </button>
//                                                     <button onClick={increaseYear}>
//                                                         <img src={doubleArrowRight} alt="double right arrow" />
//                                                     </button>
//                                                 </div>
//                                             )}
//                                         />

//                                         <style>
//                                             {`
//                                       /* Apply red circle to selected date */
//                                       .static-datepicker .react-datepicker__day--selected {
//                                         background-color: #F14B56 !important; /* Red circle */
//                                         color: white !important;
//                                         border-radius: 50%;
//                                       }
                                      
//                                       /* Ensure no extra selection styles appear */
//                                       .static-datepicker .react-datepicker__day--keyboard-selected {
//                                         background-color: transparent !important; /* Remove default selection */
//                                         color: inherit !important;
//                                       }
//                                     `}
//                                         </style>

//                                     </Box>
//                                 ) : (
//                                     <>
//                                        <FormControlLabel
//   control={
//     <Checkbox
//       checked={filters[tab.key]["all"]?.checked || false}
//       onChange={(event) => handleFilterChange(tab.key, event)}
//       name="all"
//     />
//   }
//     label={
//     tab.key === "team"
//       ? "All Teams"
//       : tab.key === "module"
//       ? "All Roles"
//       : "Select All"
//   }
// />

// {Object.keys(filters[tab.key])
//   .filter((key) => key !== "all")
//   .map((filterKey) => (
//     <FormControlLabel
//       key={filterKey}
//       sx={{ display: "block" }}
//       control={
//         <Checkbox
//           checked={filters[tab.key][filterKey]?.checked || false}
//           onChange={(event) => handleFilterChange(tab.key, event)}
//           name={filterKey}
//         />
//       }
//       label={capitalize(filterKey)}
//     />
//   ))}

//                                     </>
//                                 )}
//                             </Box>
//                         ) : null
//                     )}

//                 </Box>
//             </Box>

//             <Box
//                 sx={{
//                     marginTop: "1rem",
//                     width: "100%",
//                     justifyContent: "end",
//                     display: "flex",
//                     borderTop: "1px solid #ddd",
//                 }}
//             >
//                 <Button sx={clearButtonStyles} onClick={clearAllFilters}>
//                     Clear All
//                 </Button>
//                 {/* <Button sx={applyButtonStyles} onClick={applyFilters}>
//                     Apply
//                 </Button> */}
//                  <Button
//           sx={applyButtonStyles}
//           onClick={() => {
//             applyFilters();
//             filter?.onClose?.(); // Close the popup
//           }}
//         >
//           Apply
//         </Button>

//             </Box>
//         </Box>
//     );
// }

// // Styles
// const tabStyles = {
//     whiteSpace: "nowrap",
//     fontSize: "14px",
//     color: "#282829",
//     fontWeight: "500",
//     textTransform: "capitalize",
//     alignItems: "start",
//     "&:hover": { backgroundColor: "#F9FBFC" },
//     "&.Mui-selected": { backgroundColor: "#F9FBFC", color: "#000" },
// };

// const clearButtonStyles = {
//     border: "1px solid #E7E8E9",
//     color: "#000",
//     marginTop: "20px",
//     borderRadius: "10px",
//     marginRight: "10px",
//     height: "44px",
//     padding: "15px 15px",
//     textTransform: "none"

// };

// const applyButtonStyles = {
//     border: "1px solid #C8172F",
//     color: "#C8172F",
//     marginTop: "20px",
//     borderRadius: "10px",
//     height: "44px",
//     padding: "15px 15px",
//     textTransform: "none"

// };

// const capitalize = (string: string) =>
//     string.charAt(0).toUpperCase() + string.slice(1);

// // export default FilterPopupTeam;
// import React, { useState, useEffect, useRef, SyntheticEvent } from "react";
// import {
//   Box,
//   Button,
//   Typography,
//   Tabs,
//   Tab,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";
// import DatePicker from "react-datepicker";
// import arrowLeft from "../../../src/assests/images/arrow-left.svg";
// import arrowRight from "../../../src/assests/images/arrow-right.png";
// import doubleArrowLeft from "../../../src/assests/images/double-arrow-left.svg";
// import doubleArrowRight from "../../../src/assests/images/double-arrow-right.svg";
// import { filterdata } from "./api";
// import { getToken } from "../../utils/utils";

// interface FilterPopupProps {
//   filter: any;
//   selectedDate: Date | null;
//   setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
//   selectedTab: number;
//   setSelectedTab: (tabIndex: number) => void;
//   applyFilters: (filters: Filters) => void; // Updated to pass filters
//   filters: Filters;
//   setFilters: React.Dispatch<React.SetStateAction<Filters>>;
//   applydetailes: boolean;
//   setapply: (value: boolean) => void;
//   selectedTab1: number;
//   setSelectedTab1: React.Dispatch<React.SetStateAction<number>>;
// }

// interface Filters {
//   [key: string]: {
//     [key: string]: {
//       checked: boolean;
//       id: number;
//     };
//   };
// }

// function FilterPopupTeam({
//   filter,
//   setSelectedDate,
//   selectedDate,
//   filters,
//   setFilters,
//   applyFilters,
//   applydetailes,
//   setapply,
//   selectedTab1,
//   setSelectedTab1,
// }: FilterPopupProps) {
//   const popupRef = useRef<HTMLDivElement>(null);
//   const token = getToken();
//   const [teamIdMap, setTeamIdMap] = useState<Record<string, number>>({});
//   const [moduleIdMap, setModuleIdMap] = useState<Record<string, number>>({});

//   useEffect(() => {
//     const fetchFilterData = async () => {
//       try {
//         const res = await filterdata(token);
//         const { team = [], module = [] } = res?.data?.data || {};

//         const teamIdMap: Record<string, number> = {};
//         team.forEach((item: any) => {
//           if (item.name !== null) teamIdMap[item.name] = item.id;
//         });

//         const moduleIdMap: Record<string, number> = {};
//         module.forEach((item: any) => {
//           if (item.name !== null) moduleIdMap[item.name] = item.id;
//         });

//         setTeamIdMap(teamIdMap);
//         setModuleIdMap(moduleIdMap);

//         // Only initialize filters if they are empty
//         if (Object.keys(filters.team).length === 0 && Object.keys(filters.module).length === 0) {
//           const teamOptions = {
//             all: { checked: false, id: -1 },
//             ...Object.fromEntries(
//               team
//                 .filter((item: any) => item.name !== null)
//                 .map((item: any) => [item.name, { checked: false, id: item.id }])
//             ),
//           };

//           const moduleOptions = {
//             all: { checked: false, id: -1 },
//             ...Object.fromEntries(
//               module
//                 .filter((item: any) => item.name !== null)
//                 .map((item: any) => [item.name, { checked: false, id: item.id }])
//             ),
//           };

//           setFilters({
//             team: teamOptions,
//             module: moduleOptions,
//             creationDate: {},
//           });
//         }
//       } catch (error) {
//         console.error("Error fetching filter data:", error);
//       }
//     };

//     fetchFilterData();
//   }, [token, filters, setFilters]);
// const handleFilterChange = (tabKey: string, event: React.ChangeEvent<HTMLInputElement>) => {
//   const { name, checked } = event.target;
//   setFilters((prevFilters) => {
//     const updatedTab = { ...prevFilters[tabKey] };

//     if (name === "all") {
//       // If "All" is checked/unchecked, update all options
//       Object.keys(updatedTab).forEach((key) => {
//         updatedTab[key] = {
//           ...updatedTab[key],
//           checked,
//         };
//       });
//     } else {
//       // Update the specific option
//       updatedTab[name] = {
//         ...updatedTab[name],
//         checked,
//       };

//       // If unchecking an individual option, uncheck "All"
//       if (!checked) {
//         updatedTab["all"] = {
//           ...updatedTab["all"],
//           checked: false,
//         };
//       } else {
//         // If checking an individual option, check if all others are checked to update "All"
//         const allChecked = Object.keys(updatedTab)
//           .filter((key) => key !== "all")
//           .every((key) => updatedTab[key].checked);
//         updatedTab["all"] = {
//           ...updatedTab["all"],
//           checked: allChecked,
//         };
//       }
//     }

//     return {
//       ...prevFilters,
//       [tabKey]: updatedTab,
//     };
//   });
// };

//   const clearAllFilters = () => {
//     const clearedFilters: Filters = Object.fromEntries(
//       Object.entries(filters).map(([tabKey, options]) => [
//         tabKey,
//         Object.fromEntries(
//           Object.entries(options).map(([name, value]) => [
//             name,
//             { ...value, checked: false },
//           ])
//         ),
//       ])
//     );
//     setFilters(clearedFilters);
//     setSelectedDate(null); // Clear date filter as well
//     setapply(false); // Reset apply state
//   };

//   const tabsConfig = [
//     { label: "Team", key: "team" },
//     { label: "Module", key: "module" },
//     { label: "Creation Date", key: "creationDate" },
//   ];

//   function handleTabChange(event: SyntheticEvent<Element, Event>, value: any): void {
//     throw new Error("Function not implemented.");
//   }

//   return (
//     <Box
//       ref={popupRef}
//       sx={{
//         position: "absolute",
//         width: "480px",
//         right: "3%",
//         backgroundColor: "#fff",
//         padding: "20px",
//         borderRadius: "10px",
//         opacity: 1,
//         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
//         zIndex: 9999,
//       }}
//     >
//       <Box sx={{ width: "100%", display: "flex" }}>
//         {/* Vertical Tabs */}
//         <Box sx={{ width: "200px", borderRight: "1px solid #ddd" }}>
//           <Tabs
//             orientation="vertical"
//             value={selectedTab1}
//             onChange={handleTabChange}
//             aria-label="Filter tabs"
//             sx={{
//               borderRight: 1,
//               borderColor: "divider",
//               whiteSpace: "nowrap",
//               fontSize: "14px",
//               color: "#282829",
//               fontWeight: "500",
//               textAlign: "left",
//             }}
//           >
//             {tabsConfig.map((tab, index) => (
//               <Tab key={tab.key} label={tab.label} sx={tabStyles} />
//             ))}
//           </Tabs>
//         </Box>

//         {/* Tab Content */}
//         <Box sx={{ paddingLeft: "20px", flexGrow: 1 }}>
//           {tabsConfig.map((tab, index) =>
//             selectedTab1 === index ? (
//               <Box key={tab.key} sx={{ marginBottom: "16px" }}>
//                 {tab.key === "creationDate" ? (
//                   <Box>
//                     <style>
//                       {`
//                         .static-datepicker {
//                           position: static !important;
//                           box-shadow: none !important;
//                           border: 0px solid #ddd;
//                         }
//                         .static-datepicker .react-datepicker__day--selected {
//                           background-color: #F14B56 !important;
//                           color: white !important;
//                           border-radius: 50%;
//                         }
//                         .static-datepicker .react-datepicker__day--keyboard-selected {
//                           background-color: transparent !important;
//                           color: inherit !important;
//                         }
//                       `}
//                     </style>
//                     <DatePicker
//                       dateFormat="dd/MM/yyyy"
//                       selected={selectedDate}
//                       onChange={(date) => {
//                         setSelectedDate(date);
//                         console.log(date, "Selected Datesssssssssss");
//                       }}
//                       inline
//                       calendarClassName="static-datepicker"
//                       dayClassName={(date) =>
//                         selectedDate && date.toDateString() === selectedDate.toDateString()
//                           ? "selected-date"
//                           : ""
//                       }
//                       renderCustomHeader={({ date, decreaseMonth, increaseMonth, decreaseYear, increaseYear }) => (
//                         <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
//                           <button onClick={decreaseYear}>
//                             <img src={doubleArrowLeft} alt="double left arrow" />
//                           </button>
//                           <button onClick={decreaseMonth}>
//                             <img src={arrowLeft} alt="left arrow" />
//                           </button>
//                           <span style={{ margin: "0 10px" }}>
//                             {date.toLocaleString("default", { year: "numeric", month: "long" })}
//                           </span>
//                           <button onClick={increaseMonth}>
//                             <img src={arrowRight} alt="right arrow" />
//                           </button>
//                           <button onClick={increaseYear}>
//                             <img src={doubleArrowRight} alt="double right arrow" />
//                           </button>
//                         </div>
//                       )}
//                     />
//                   </Box>
//                 ) : (
//                   <>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={filters[tab.key]["all"]?.checked || false}
//                           onChange={(event) => handleFilterChange(tab.key, event)}
//                           name="all"
//                         />
//                       }
//                       label={
//                         tab.key === "team"
//                           ? "All Teams"
//                           : tab.key === "module"
//                           ? "All Roles"
//                           : "Select All"
//                       }
//                     />
//                     {Object.keys(filters[tab.key])
//                       .filter((key) => key !== "all")
//                       .map((filterKey) => (
//                         <FormControlLabel
//                           key={filterKey}
//                           sx={{ display: "block" }}
//                           control={
//                             <Checkbox
//                               checked={filters[tab.key][filterKey]?.checked || false}
//                               onChange={(event) => handleFilterChange(tab.key, event)}
//                               name={filterKey}
//                             />
//                           }
//                           label={capitalize(filterKey)}
//                         />
//                       ))}
//                   </>
//                 )}
//               </Box>
//             ) : null
//           )}
//         </Box>
//       </Box>

//       <Box
//         sx={{
//           marginTop: "1rem",
//           width: "100%",
//           justifyContent: "end",
//           display: "flex",
//           borderTop: "1px solid #ddd",
//         }}
//       >
//         <Button sx={clearButtonStyles} onClick={clearAllFilters}>
//           Clear All
//         </Button>
//         <Button
//           sx={applyButtonStyles}
//           onClick={() => {
//             applyFilters(filters); // Pass filters to parent
//             setapply(true); // Set apply state
//             filter?.onClose?.(); // Close the popup
//           }}
//         >
//           Apply
//         </Button>
//       </Box>
//     </Box>
//   );
// }

// // Styles
// const tabStyles = {
//   whiteSpace: "nowrap",
//   fontSize: "14px",
//   color: "#282829",
//   fontWeight: "500",
//   textTransform: "capitalize",
//   alignItems: "start",
//   "&:hover": { backgroundColor: "#F9FBFC" },
//   "&.Mui-selected": { backgroundColor: "#F9FBFC", color: "#000" },
// };

// const clearButtonStyles = {
//   border: "1px solid #E7E8E9",
//   color: "#000",
//   marginTop: "20px",
//   borderRadius: "10px",
//   marginRight: "10px",
//   height: "44px",
//   padding: "15px 15px",
//   textTransform: "none",
// };

// const applyButtonStyles = {
//   border: "1px solid #C8172F",
//   color: "#C8172F",
//   marginTop: "20px",
//   borderRadius: "10px",
//   height: "44px",
//   padding: "15px 15px",
//   textTransform: "none",
// };

// const capitalize = (string: string) =>
//   string.charAt(0).toUpperCase() + string.slice(1);

// export default FilterPopupTeam;
import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  Tabs,
  Tab,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import DatePicker from "react-datepicker";
import arrowLeft from "../../../src/assests/images/arrow-left.svg";
import arrowRight from "../../../src/assests/images/arrow-right.png";
import doubleArrowLeft from "../../../src/assests/images/double-arrow-left.svg";
import doubleArrowRight from "../../../src/assests/images/double-arrow-right.svg";
import { filterdata } from "./api";
import { getToken } from "../../utils/utils";

interface FilterPopupProps {
  filter: any;
  selectedDate: Date | null;
  setSelectedDate: React.Dispatch<React.SetStateAction<Date | null>>;
  selectedTab: number;
  setSelectedTab: (tabIndex: number) => void;
  applyFilters: (filters: Filters) => void;
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  applydetailes: boolean;
  setapply: (value: boolean) => void;
  selectedTab1: number;
  setSelectedTab1: React.Dispatch<React.SetStateAction<number>>;
}

interface Filters {
  [key: string]: {
    [key: string]: {
      checked: boolean;
      id: number;
    };
  };
}

function FilterPopupTeam({
  filter,
  setSelectedDate,
  selectedDate,
  filters,
  setFilters,
  applyFilters,
  applydetailes,
  setapply,
  selectedTab1,
  setSelectedTab1,
}: FilterPopupProps) {
  const popupRef = useRef<HTMLDivElement>(null);
  const token = getToken();
  const [teamIdMap, setTeamIdMap] = useState<Record<string, number>>({});
  const [moduleIdMap, setModuleIdMap] = useState<Record<string, number>>({});

  useEffect(() => {
    const fetchFilterData = async () => {
      try {
        const res = await filterdata(token);
        const { team = [], module = [] } = res?.data?.data || {};

        const teamIdMap: Record<string, number> = {};
        team.forEach((item: any) => {
          if (item.name !== null) teamIdMap[item.name] = item.id;
        });

        const moduleIdMap: Record<string, number> = {};
        module.forEach((item: any) => {
          if (item.name !== null) moduleIdMap[item.name] = item.id;
        });

        setTeamIdMap(teamIdMap);
        setModuleIdMap(moduleIdMap);

        // Only initialize filters if they are empty
        if (Object.keys(filters.team).length === 0 && Object.keys(filters.module).length === 0) {
          const teamOptions = {
            all: { checked: false, id: -1 },
            ...Object.fromEntries(
              team
                .filter((item: any) => item.name !== null)
                .map((item: any) => [item.name, { checked: false, id: item.id }])
            ),
          };

          const moduleOptions = {
            all: { checked: false, id: -1 },
            ...Object.fromEntries(
              module
                .filter((item: any) => item.name !== null)
                .map((item: any) => [item.name, { checked: false, id: item.id }])
            ),
          };

          setFilters({
            team: teamOptions,
            module: moduleOptions,
            creationDate: {},
          });

          // Debug: Log initialized filters
          console.log("Initialized filters:", { teamOptions, moduleOptions });
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    fetchFilterData();
  }, [token, filters, setFilters]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab1(newValue);
  };

  const handleFilterChange = (tabKey: string, event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setFilters((prevFilters) => {
      const updatedTab = { ...prevFilters[tabKey] };

      // Debug: Log the tab and checkbox being changed
      console.log(`Handling filter change for tab: ${tabKey}, name: ${name}, checked: ${checked}`);

      if (name === "all") {
        // If "All" is checked/unchecked, update all options
        Object.keys(updatedTab).forEach((key) => {
          updatedTab[key] = {
            ...updatedTab[key],
            checked,
          };
        });
      } else {
        // Update the specific option
        updatedTab[name] = {
          ...updatedTab[name],
          checked,
        };

        // If unchecking an individual option, uncheck "All"
        if (!checked) {
          updatedTab["all"] = {
            ...updatedTab["all"],
            checked: false,
          };
        } else {
          // If checking an individual option, check if all others are checked to update "All"
          const allChecked = Object.keys(updatedTab)
            .filter((key) => key !== "all")
            .every((key) => updatedTab[key].checked);
          updatedTab["all"] = {
            ...updatedTab["all"],
            checked: allChecked,
          };
        }
      }

      // Debug: Log updated filters
      console.log(`Updated filters for ${tabKey}:`, updatedTab);

      return {
        ...prevFilters,
        [tabKey]: updatedTab,
      };
    });
  };

  const clearAllFilters = () => {
    const clearedFilters: Filters = Object.fromEntries(
      Object.entries(filters).map(([tabKey, options]) => [
        tabKey,
        Object.fromEntries(
          Object.entries(options).map(([name, value]) => [
            name,
            { ...value, checked: false },
          ])
        ),
      ])
    );
    setFilters(clearedFilters);
    setSelectedDate(null);
    setapply(false);
  };

  const tabsConfig = [
    { label: "Team", key: "team" },
    { label: "Module", key: "module" },
    { label: "Creation Date", key: "creationDate" },
  ];
console.log(selectedTab1, "selectedTab1selectedTab1sssssssssssss")
  return (
    <Box
      ref={popupRef}
      sx={{
        position: "absolute",
        width: "480px",
        right: "3%",
        backgroundColor: "#fff",
        padding: "20px",
        borderRadius: "10px",
        opacity: 1,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        zIndex: 9999,
      }}
    >
      <Box sx={{ width: "100%", display: "flex" }}>
        {/* Vertical Tabs */}
        <Box sx={{ width: "200px", borderRight: "1px solid #ddd" }}>
          <Tabs
            orientation="vertical"
            value={selectedTab1}
            onChange={handleTabChange}
            aria-label="Filter tabs"
            sx={{
              borderRight: 1,
              borderColor: "divider",
              whiteSpace: "nowrap",
              fontSize: "14px",
              color: "#282829",
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            {tabsConfig.map((tab, index) => (
              <Tab key={tab.key} label={tab.label} sx={tabStyles} />
            ))}
          </Tabs>
        </Box>

        {/* Tab Content */}
        <Box sx={{ paddingLeft: "20px", flexGrow: 1 }}>
          {tabsConfig.map((tab, index) =>
            selectedTab1 === index ? (
              <Box key={tab.key} sx={{ marginBottom: "16px" }}>
                {tab.key === "creationDate" ? (
                  <Box>
                    <style>
                      {`
                        .static-datepicker {
                          position: static !important;
                          box-shadow: none !important;
                          border: 0px solid #ddd;
                        }
                        .static-datepicker .react-datepicker__day--selected {
                          background-color: #F14B56 !important;
                          color: white !important;
                          border-radius: 50%;
                        }
                        .static-datepicker .react-datepicker__day--keyboard-selected {
                          background-color: transparent !important;
                          color: inherit !important;
                        }
                      `}
                    </style>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      selected={selectedDate}
                      onChange={(date) => {
                        setSelectedDate(date);
                        console.log(date, "Selected Datesssssssssss");
                      }}
                      inline
                      calendarClassName="static-datepicker"
                      dayClassName={(date) =>
                        selectedDate && date.toDateString() === selectedDate.toDateString()
                          ? "selected-date"
                          : ""
                      }
                      renderCustomHeader={({ date, decreaseMonth, increaseMonth, decreaseYear, increaseYear }) => (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <button onClick={decreaseYear}>
                            <img src={doubleArrowLeft} alt="double left arrow" />
                          </button>
                          <button onClick={decreaseMonth}>
                            <img src={arrowLeft} alt="left arrow" />
                          </button>
                          <span style={{ margin: "0 10px" }}>
                            {date.toLocaleString("default", { year: "numeric", month: "long" })}
                          </span>
                          <button onClick={increaseMonth}>
                            <img src={arrowRight} alt="right arrow" />
                          </button>
                          <button onClick={increaseYear}>
                            <img src={doubleArrowRight} alt="double right arrow" />
                          </button>
                        </div>
                      )}
                    />
                  </Box>
                ) : (
                  <>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={filters[tab.key]["all"]?.checked || false}
                          onChange={(event) => handleFilterChange(tab.key, event)}
                          name="all"
                        />
                      }
                      label={
                        tab.key === "team"
                          ? "All Teams"
                          : tab.key === "module"
                          ? "All Roles"
                          : "Select All"
                      }
                    />
                    {Object.keys(filters[tab.key])
                      .filter((key) => key !== "all")
                      .map((filterKey) => (
                        <FormControlLabel
                          key={filterKey}
                          sx={{ display: "block" }}
                          control={
                            <Checkbox
                              checked={filters[tab.key][filterKey]?.checked || false}
                              onChange={(event) => handleFilterChange(tab.key, event)}
                              name={filterKey}
                            />
                          }
                          label={capitalize(filterKey)}
                        />
                      ))}
                  </>
                )}
              </Box>
            ) : null
          )}
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "1rem",
          width: "100%",
          justifyContent: "end",
          display: "flex",
          borderTop: "1px solid #ddd",
        }}
      >
        <Button sx={clearButtonStyles} onClick={clearAllFilters}>
          Clear All
        </Button>
        <Button
          sx={applyButtonStyles}
          onClick={() => {
            applyFilters(filters);
            setapply(true);
            filter?.onClose?.();
          }}
        >
          Apply
        </Button>
      </Box>
    </Box>
  );
}

// Styles
const tabStyles = {
  whiteSpace: "nowrap",
  fontSize: "14px",
  color: "#282829",
  fontWeight: "500",
  textTransform: "capitalize",
  alignItems: "start",
  "&:hover": { backgroundColor: "#F9FBFC" },
  "&.Mui-selected": { backgroundColor: "#F9FBFC", color: "#000" },
};

const clearButtonStyles = {
  border: "1px solid #E7E8E9",
  color: "#000",
  marginTop: "20px",
  borderRadius: "10px",
  marginRight: "10px",
  height: "44px",
  padding: "15px 15px",
  textTransform: "none",
};

const applyButtonStyles = {
  border: "1px solid #C8172F",
  color: "#C8172F",
  marginTop: "20px",
  borderRadius: "10px",
  height: "44px",
  padding: "15px 15px",
  textTransform: "none",
};

const capitalize = (string: string) =>
  string.charAt(0).toUpperCase() + string.slice(1);

export default FilterPopupTeam;